import React, { useEffect, useState } from "react";
import Card from "components/card";
import { Button, Spinner, IconButton } from "@material-tailwind/react";
import { IoEyeSharp } from "react-icons/io5";
import { HiPencilAlt } from "react-icons/hi";
import { FaTrash } from "react-icons/fa";
import { MdPictureAsPdf } from "react-icons/md";
import { RiFileExcel2Fill } from "react-icons/ri";

import {
  IoMdArrowDropleftCircle,
  IoMdArrowDroprightCircle,
} from "react-icons/io";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { Dialog, DialogHeader, DialogBody, DialogFooter } from "@material-tailwind/react";
import { Combobox } from "@headlessui/react";

import OperationForm from "./Operation_form";
import OperationProducts from "./Operation_products";
import OperationReports from "./Operation_reports";
import { getAllTcpsApi, getReportClientNamesApi } from "api/filtersData";
import { getAllOpReportsListApi, getAllOpReportsListAllApi } from "api/operations";
import { updateReportDataApi } from "api/gestionStock";
import { updateOneEssayStatusReportsApi } from "api/essay";

function ListOfOperations({ accessList }) {
  const [showOperationForm, setOperationForm] = useState(false);
  const [showOperationReports, setOperationReports] = useState(false);
  const [showOperationProducts, setOperationProducts] = useState(false);
  const [showClotureDialog, setShowClotureDialog] = useState(false);
  const [clotureTarget, setClotureTarget] = useState(null);
  const [clotureComment, setClotureComment] = useState("");
  const [isSubmittingCloture, setIsSubmittingCloture] = useState(false);

  const [selectedOperation, setSelectedOperation] = useState({})

  const [listOfOperations, setListOfOperations] = useState([]);
  const [listOfAllTcp, setListOfTcp] = useState([])
  // List of distinct client names actually present in the reports table
  // (InfoGenerale.NomSociete) — guarantees every option here has a real match.
  const [listOfReportClientNames, setListOfReportClientNames] = useState([])
  const [clientQuery, setClientQuery] = useState("")

  const [inputFilterValue, setInputFilterValue] = useState({
    TCP: "",
    MP: "Devis",
    currentYear: new Date().getUTCFullYear(),
    ClientName: "",
    Phone: ""
  });

  const filteredClientComboBoxData =
    clientQuery === ""
      ? listOfReportClientNames
      : listOfReportClientNames.filter((name) =>
          (name || "")
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(clientQuery.toLowerCase().replace(/\s+/g, ""))
        );

  const [isLoading, setIsLoading] = useState(false);
  const [selectedOp, setSelectedOp] = useState({})

  // paginations
  const [active, setActive] = useState(1);
  const [currentPagination, setCurrentPagination] = useState(1);

  const [numberOfPages, setNumberOfPages] = useState(0);
  const [numberOfPaginations, setNumberOfPaginations] = useState(0);
  const [numberOfReports, setNumberOfReports] = useState(0);

  useEffect(() => {
    getListOfAllTcp()
    getListOfReportClientNames()
  }, [])

  useEffect(() => {
    getInitialData(
      inputFilterValue.MP,
      inputFilterValue.TCP,
      "",
      inputFilterValue.currentYear,
      "",
      "",
      "",
      inputFilterValue.ClientName,
      inputFilterValue.Phone,
      active
    );
  }, [inputFilterValue]);

  const handleFiltersInputChange = async (e) => {
    try {
      setIsLoading(true)

      const { name, value } = e.target;
      setInputFilterValue((prevInputFilterValue) => ({
        ...prevInputFilterValue,
        [name]: value,
      }));

      await getInitialData(
        name === "MP" ? value : inputFilterValue.MP,
        name === "TCP" ? value : inputFilterValue.TCP,
        "",
        name === "currentYear" ? value : inputFilterValue.currentYear,
        "",
        "",
        "",
        inputFilterValue.ClientName,
        name === "Phone" ? value : inputFilterValue.Phone,
        active
      );
    }
    catch (err){
      console.log(err)
    }
    finally {
      setActive(1)
      setCurrentPagination(1)

      setIsLoading(false)
    }
  };

  const handleClientFilterChange = async (clientName) => {
    try {
      setIsLoading(true)

      setInputFilterValue((prevInputFilterValue) => ({
        ...prevInputFilterValue,
        ClientName: clientName,
      }));

      await getInitialData(
        inputFilterValue.MP,
        inputFilterValue.TCP,
        "",
        inputFilterValue.currentYear,
        "",
        "",
        "",
        clientName,
        inputFilterValue.Phone,
        active
      );
    }
    catch (err) {
      console.log(err)
    }
    finally {
      setActive(1)
      setCurrentPagination(1)

      setIsLoading(false)
    }
  };

  const getListOfAllTcp = async () => {
    try {
      const response = await getAllTcpsApi()
      setListOfTcp(response)
    }
    catch (err) {
      console.log(err)
    }
  }

  const getListOfReportClientNames = async () => {
    try {
      const response = await getReportClientNamesApi()
      setListOfReportClientNames(response)
    }
    catch (err) {
      console.log(err)
    }
  }

  const getInitialData = async (MP, TCP, OP, currentYear, RBC, RBL, RF, ClientName, Phone, Page) => {
    try {
      setIsLoading(true);
      const response = await getAllOpReportsListApi(MP, TCP, OP, currentYear, RBC, RBL, RF, ClientName, Phone, Page);

      setListOfOperations(response.data);
      setNumberOfPages(response.pagination.numberOfPages);
      setNumberOfPaginations(response.pagination.numberOfPaginations);
      setNumberOfReports(response.pagination.numberOfReports);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteReport = (ID) => {
    try {
      withReactContent(Swal)
        .fire({
          icon: "warning",
          title: "Supprimer ?",
          confirmButtonText: "Supprimer",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const updatedObject = {
              isArchieved: true
            };
            await updateReportDataApi(ID, updatedObject)

            getInitialData(
              inputFilterValue.MP,
              inputFilterValue.TCP,
              "",
              inputFilterValue.currentYear,
              "",
              "",
              "",
              inputFilterValue.ClientName,
              inputFilterValue.Phone,
              active
            );

            Swal.fire("Supprimée", "", "success");
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  const handleOpenClotureDialog = (el) => {
    setClotureTarget(el);
    setClotureComment("");
    setShowClotureDialog(true);
  };

  const handleCancelCloture = () => {
    setShowClotureDialog(false);
    setClotureTarget(null);
    setClotureComment("");
  };

  const handleConfirmCloture = async () => {
    if (!clotureComment || clotureComment.trim() === "") {
      return Swal.fire("Veuillez saisir le motif de clôture", "", "warning");
    }

    try {
      setIsSubmittingCloture(true);
      await updateOneEssayStatusReportsApi(clotureTarget._id, "V", clotureComment);

      setShowClotureDialog(false);
      setClotureTarget(null);
      setClotureComment("");

      getInitialData(
        inputFilterValue.MP,
        inputFilterValue.TCP,
        "",
        inputFilterValue.currentYear,
        "",
        "",
        "",
        inputFilterValue.ClientName,
        inputFilterValue.Phone,
        active
      );

      Swal.fire("Clôturée", "", "success");
    } catch (err) {
      console.log(err);
      Swal.fire("Erreur lors de la clôture", "", "error");
    } finally {
      setIsSubmittingCloture(false);
    }
  };

  const handleReportModal = (data) => {
    try {
      setSelectedOperation(data)
      setOperationReports(!showOperationReports);
    } catch (err) {
      console.log(err);
    }
  };
  const handleReportFormModal = (id) => {
    try {
      setOperationForm(!showOperationForm);
    } catch (err) {
      console.log(err);
    }
  };
  const handleReportProductsModal = (data) => {
    try {
      setOperationProducts(!showOperationProducts);
      setSelectedOp(data)
    } catch (err) {
      console.log(err);
    }
  };

    // pagination
    const getItemProps = (index) => ({
      variant: active === index ? "filled" : "text",
      color: "gray",
      onClick: () => {
        getInitialData(
          inputFilterValue.MP,
          inputFilterValue.TCP,
          "",
          inputFilterValue.currentYear,
          "",
          "",
          "",
          inputFilterValue.ClientName,
          inputFilterValue.Phone,
          index
        );
        setActive(index);
      },
    });
  
    const next = () => {
      if (currentPagination === numberOfPaginations) return;
      setCurrentPagination(currentPagination + 1);
    };
  
    const prev = () => {
      if (currentPagination === 1) return;
      setCurrentPagination(currentPagination - 1);
    };
    // pagination

  const handleExportExcel = async () => {
    try {
      const allData = await getAllOpReportsListAllApi(
        inputFilterValue.MP,
        inputFilterValue.TCP,
        "",
        inputFilterValue.currentYear,
        "",
        "",
        "",
        inputFilterValue.ClientName,
        inputFilterValue.Phone,
        numberOfReports
      );
      const allRecords = allData?.data || [];

      // Build XML for a real .xlsx (SpreadsheetML) file — no external dependency needed
      const isProspection = inputFilterValue.MP === "Prospection";

      const arrToStr = (val) =>
        Array.isArray(val) ? val.filter(Boolean).join(", ") : (val || "");

      const headers = isProspection
        ? [
            "Date",
            "TCP",
            "Zone",
            "Client",
            "Téléphone",
            "Personne à contacter",
            "Type de visite",
            "Propriétaire",
            "Décideur",
            "Culture",
            "Superficie (ha)",
            "Type de culture",
            "Stade & Diagnostic",
            "Solutions proposées",
            "Concurrences Société",
            "Concurrences Produit",
            "Concurrences Prix",
            "Commentaire",
          ]
        : ["Date", "Opération", "N°", "TCP", "Nom", "Commentaire"];

      const rows = allRecords.flatMap((el) => {
        if (isProspection) {
          const P = el.Prospection || el.Rapport || {};
          const details = P.concurrencesDetails || {};
          const toArr = (v) => Array.isArray(v) ? v.filter(Boolean) : (v ? String(v).split(/\s*\|\s*/).filter(Boolean) : []);
          const cultureArr = toArr(P.culture);
          const superficieArr = toArr(P.nombreParHectar);
          const typeCultureArr = toArr(P.typeCulture);
          const solutionsArr = toArr(P.solutionsProposees);
          const societeArr = toArr(details.societe);
          const produitArr = toArr(details.produit);
          const prixArr = toArr(details.prix);
          const proprietaireArr = toArr(P.proprietaire);
          const decideurArr = toArr(P.decideur);
          const maxLen = Math.max(1, cultureArr.length, superficieArr.length, typeCultureArr.length, solutionsArr.length, societeArr.length, produitArr.length, prixArr.length, proprietaireArr.length, decideurArr.length);
          return Array.from({ length: maxLen }, (_, i) => [
            i === 0 ? (el?.CurrentDate || (el?.createdAt ? new Date(el.createdAt).toLocaleDateString("fr-FR") : "")) : "",
            i === 0 ? (el.for?.Name || "") : "",
            i === 0 ? arrToStr(P.zone) : "",
            i === 0 ? (el.InfoGenerale?.NomSociete || "") : "",
            i === 0 ? (el.InfoGenerale?.Tel || "") : "",
            i === 0 ? (P.personneContacte || "") : "",
            i === 0 ? (P.type || "") : "",
            proprietaireArr[i] || "",
            decideurArr[i] || "",
            cultureArr[i] || "",
            superficieArr[i] || "",
            typeCultureArr[i] || "",
            i === 0 ? (P.stadeDiagnostic || "") : "",
            solutionsArr[i] || "",
            societeArr[i] || "",
            produitArr[i] || "",
            prixArr[i] || "",
            i === 0 ? (P.commentaire || P.description || "") : "",
          ]);
        }
        return [[
          el?.CurrentDate || (el?.createdAt ? new Date(el.createdAt).toLocaleDateString("fr-FR") : ""),
          el.ModeOperation,
          el.ModeOperation === "Devis" ? el.RBC : "",
          el.for?.Name || "",
          el.InfoGenerale?.NomSociete || "",
          el?.Comment || "",
        ]];
      });

    const escapeXml = (val) =>
      String(val ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");

    const allRows = [headers, ...rows];

    // Header row: bold, larger font, shaded background, taller row (style s="1").
    // Data rows: small font, thin borders (style s="2").
    const sheetRows = allRows
      .map((row, rowIndex) => {
        const isHeader = rowIndex === 0;
        const styleAttr = isHeader ? ' s="1"' : ' s="2"';
        const rowAttr = isHeader ? ' ht="22" customHeight="1"' : "";
        const cells = row
          .map((cell) => `<c${styleAttr} t="inlineStr"><is><t>${escapeXml(cell)}</t></is></c>`)
          .join("");
        return `<row${rowAttr}>${cells}</row>`;
      })
      .join("");

    // Approximate auto-fit column widths from the longest value in each column.
    const colWidths = headers.map((_, colIdx) => {
      const maxLen = allRows.reduce((max, row) => {
        const cellStr = String(row[colIdx] ?? "");
        return Math.max(max, cellStr.length);
      }, 0);
      return Math.min(Math.max(maxLen + 2, 10), 60);
    });
    const colsXml = `<cols>${colWidths
      .map((w, i) => `<col min="${i + 1}" max="${i + 1}" width="${w}" customWidth="1"/>`)
      .join("")}</cols>`;

    const sheetXml = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">
  ${colsXml}
  <sheetData>${sheetRows}</sheetData>
</worksheet>`;

    const stylesXml = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">
  <fonts count="3">
    <font><sz val="11"/><name val="Calibri"/></font>
    <font><b/><sz val="12"/><name val="Calibri"/></font>
    <font><sz val="9"/><name val="Calibri"/></font>
  </fonts>
  <fills count="3">
    <fill><patternFill patternType="none"/></fill>
    <fill><patternFill patternType="gray125"/></fill>
    <fill><patternFill patternType="solid"><fgColor rgb="FFE2E8F0"/><bgColor indexed="64"/></patternFill></fill>
  </fills>
  <borders count="2">
    <border><left/><right/><top/><bottom/><diagonal/></border>
    <border><left style="thin"><color rgb="FFB0B0B0"/></left><right style="thin"><color rgb="FFB0B0B0"/></right><top style="thin"><color rgb="FFB0B0B0"/></top><bottom style="thin"><color rgb="FFB0B0B0"/></bottom><diagonal/></border>
  </borders>
  <cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>
  <cellXfs count="3">
    <xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>
    <xf numFmtId="0" fontId="1" fillId="2" borderId="1" xfId="0" applyFont="1" applyFill="1" applyBorder="1" applyAlignment="1"><alignment horizontal="center" vertical="center" wrapText="1"/></xf>
    <xf numFmtId="0" fontId="2" fillId="0" borderId="1" xfId="0" applyFont="1" applyBorder="1" applyAlignment="1"><alignment vertical="center" wrapText="1"/></xf>
  </cellXfs>
  <cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>
</styleSheet>`;

    const workbookXml = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"
          xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">
  <sheets><sheet name="Operations" sheetId="1" r:id="rId1"/></sheets>
</workbook>`;

    const relsXml = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
  <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/>
  <Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/>
</Relationships>`;

    const contentTypesXml = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">
  <Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>
  <Default Extension="xml" ContentType="application/xml"/>
  <Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>
  <Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>
  <Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>
</Types>`;

    // Build zip (xlsx) using JSZip-free base64 trick via data URIs isn't viable for binary zip,
    // so we use a minimal zip builder inline
    const toUint8 = (str) => new TextEncoder().encode(str);
    const crc32 = (buf) => {
      const table = new Uint32Array(256).map((_, i) => {
        let c = i;
        for (let k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
        return c;
      });
      let crc = 0xffffffff;
      for (const b of buf) crc = table[(crc ^ b) & 0xff] ^ (crc >>> 8);
      return (crc ^ 0xffffffff) >>> 0;
    };
    const u32le = (n) => [(n) & 0xff, (n >> 8) & 0xff, (n >> 16) & 0xff, (n >> 24) & 0xff];
    const u16le = (n) => [(n) & 0xff, (n >> 8) & 0xff];

    const buildLocalFile = (name, data) => {
      const nameBytes = new TextEncoder().encode(name);
      const crc = crc32(data);
      const header = [
        0x50, 0x4b, 0x03, 0x04, // signature
        20, 0,                   // version needed
        0, 0,                    // flags
        0, 0,                    // compression (stored)
        0, 0, 0, 0,              // mod time/date
        ...u32le(crc),
        ...u32le(data.length),   // compressed size
        ...u32le(data.length),   // uncompressed size
        ...u16le(nameBytes.length),
        0, 0,                    // extra field length
        ...nameBytes,
      ];
      return { header: new Uint8Array(header), data, nameBytes, crc, size: data.length };
    };

    const files = [
      { name: "[Content_Types].xml", data: toUint8(contentTypesXml) },
      { name: "_rels/.rels", data: toUint8(`<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>`) },
      { name: "xl/workbook.xml", data: toUint8(workbookXml) },
      { name: "xl/_rels/workbook.xml.rels", data: toUint8(relsXml) },
      { name: "xl/worksheets/sheet1.xml", data: toUint8(sheetXml) },
      { name: "xl/styles.xml", data: toUint8(stylesXml) },
    ];

    const localFiles = files.map(f => buildLocalFile(f.name, f.data));
    const parts = [];
    const offsets = [];
    let offset = 0;
    for (const lf of localFiles) {
      offsets.push(offset);
      parts.push(lf.header, lf.data);
      offset += lf.header.length + lf.data.length;
    }

    const centralDir = localFiles.map((lf, i) => {
      const cd = [
        0x50, 0x4b, 0x01, 0x02,
        20, 0, 20, 0,
        0, 0, 0, 0, 0, 0, 0, 0,
        ...u32le(lf.crc),
        ...u32le(lf.size),
        ...u32le(lf.size),
        ...u16le(lf.nameBytes.length),
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        ...u32le(offsets[i]),
        ...lf.nameBytes,
      ];
      return new Uint8Array(cd);
    });

    const cdOffset = offset;
    const cdSize = centralDir.reduce((s, c) => s + c.length, 0);
    const eocd = new Uint8Array([
      0x50, 0x4b, 0x05, 0x06,
      0, 0, 0, 0,
      ...u16le(files.length),
      ...u16le(files.length),
      ...u32le(cdSize),
      ...u32le(cdOffset),
      0, 0,
    ]);

    const totalSize = offset + cdSize + eocd.length;
    const buf = new Uint8Array(totalSize);
    let pos = 0;
    for (const p of [...parts, ...centralDir, eocd]) {
      buf.set(p, pos);
      pos += p.length;
    }

    const blob = new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `operations_${inputFilterValue.MP}_${inputFilterValue.currentYear}.xlsx`;
    link.click();
    URL.revokeObjectURL(url);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Card extra={"w-full pb-10 p-4 h-full"}>
      <Dialog
        size="xl"
        open={showOperationForm}
        handler={handleReportFormModal}
      >
        <DialogHeader>
          <p className="w-full text-center">Modifier un rapport</p>
        </DialogHeader>
        <DialogBody>
          <OperationForm
            closePopup={handleReportFormModal}
            operationFormId=""
          />
        </DialogBody>
      </Dialog>

      <Dialog size="xl" open={showOperationReports} handler={handleReportModal}>
        <DialogHeader>
          <p className="w-full text-center">Aperçu pdf details</p>
        </DialogHeader>
        <DialogBody>
          <OperationReports
            closePopup={handleReportModal}
            operationDetails={selectedOperation}
          />
        </DialogBody>
      </Dialog>

      <Dialog
        size="xl"
        open={showOperationProducts}
        handler={handleReportProductsModal}
      >
        <DialogHeader>
          <p className="w-full text-center">Aperçu</p>
        </DialogHeader>
        <DialogBody>
          <OperationProducts
            closePopup={handleReportProductsModal}
            selectedOp={selectedOp}
          />
        </DialogBody>
      </Dialog>

      <Dialog size="sm" open={showClotureDialog} handler={handleCancelCloture}>
        <DialogHeader>
          <p className="w-full text-center">Clôturer la visite d'essai</p>
        </DialogHeader>
        <DialogBody>
          <label htmlFor="" className="text-md font-bold text-navy-700">
            Motif de clôture
          </label>
          <textarea
            placeholder="Expliquez pourquoi cette visite d'essai est terminée"
            className="flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none"
            rows="6"
            value={clotureComment}
            onChange={(e) => setClotureComment(e.target.value)}
          />
        </DialogBody>
        <DialogFooter>
          <Button
            variant="text"
            color="#cf503f"
            onClick={handleCancelCloture}
            className="mr-1"
            disabled={isSubmittingCloture}
          >
            <span>Annuler</span>
          </Button>
          <Button
            variant="gradient"
            color="#236571"
            onClick={handleConfirmCloture}
            disabled={isSubmittingCloture}
          >
            <span>Clôture</span>
          </Button>
        </DialogFooter>
      </Dialog>

      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-4">
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Filtrer par client :
          </small>
          <div className="relative">
            <Combobox
              value={inputFilterValue.ClientName}
              onChange={handleClientFilterChange}
            >
              <Combobox.Input
                onChange={(event) => setClientQuery(event.target.value)}
                displayValue={(name) => name || ""}
                placeholder="Tout"
                className="relative flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none"
              />
              <Combobox.Options className="absolute z-10 mt-1 max-h-40 w-full overflow-y-scroll rounded-xl bg-white shadow-lg dark:bg-navy-800">
                <Combobox.Option
                  value=""
                  className="cursor-pointer rounded-xl p-2 hover:bg-gray-100"
                >
                  Tout
                </Combobox.Option>
                {filteredClientComboBoxData.length === 0 ? (
                  <div className="p-2 text-sm text-gray-500">
                    Aucun client trouvé
                  </div>
                ) : (
                  filteredClientComboBoxData.map((name) => (
                    <Combobox.Option
                      key={name}
                      value={name}
                      className="cursor-pointer rounded-xl p-2 hover:bg-gray-100"
                    >
                      {name}
                    </Combobox.Option>
                  ))
                )}
              </Combobox.Options>
            </Combobox>
          </div>
        </div>
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Filtrer par TCP :
          </small>
          <div>
            <select
              label="select Version"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              defaultValue=""

              name="TCP"
              value={inputFilterValue.TCP}
              onChange={handleFiltersInputChange}
            >
              <option value="">Tout</option>
              {
                listOfAllTcp.map(el => (
                  <option value={el._id}>{el.Name}</option>
                ))
              }
            </select>
          </div>
        </div>
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Filtrer par opération :
          </small>
          <div>
            <select
              label="select Version"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
              defaultValue="Devis"

              name="MP"
              value={inputFilterValue.MP}
              onChange={handleFiltersInputChange}
            >
              <option value="Devis">Devis</option>
              <option value="VisiteEssai">Visite d'essai</option>
              <option value="VisiteDeveloppement">Visite de développement</option>
              <option value="Prospection">Prospection</option>
            </select>
          </div>
        </div>
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Année :
          </small>
          <div>
            <input
              type="number"
              id=""
              placeholder="Tout"
              min="1900"
              max={new Date().getUTCFullYear()}
              step="1"
              className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}

              name="currentYear"
              value={inputFilterValue.currentYear}
              onChange={handleFiltersInputChange}
            />
          </div>
        </div>
        {
          inputFilterValue.MP === "Prospection" &&
          <div>
            <small className="text-sm font-medium text-gray-600 dark:text-white">
              Filtrer par téléphone :
            </small>
            <div>
              <input
                type="text"
                placeholder="Tout"
                className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}

                name="Phone"
                value={inputFilterValue.Phone}
                onChange={handleFiltersInputChange}
              />
            </div>
          </div>
        }
      </div>
      <div className="mt-4 flex justify-end">
        <Button
          variant="outlined"
          color="green"
          className="flex items-center gap-2"
          onClick={handleExportExcel}
          disabled={listOfOperations.length === 0}
        >
          <RiFileExcel2Fill size={18} />
          Exporter Excel
        </Button>
      </div>

      {
        isLoading ?
        <div className="flex w-full items-center justify-center">
          <Spinner className="h-12 w-12" />
        </div> :
        <div>
          <div
            className="mt-8 overflow-x-scroll"
            style={{ height: "50vh", overflowY: "scroll" }}
          >
            <table className="w-full">
              <thead>
                <tr>
                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">Date</p>
                  </th>
                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">Opération</p>
                  </th>
                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">N°</p>
                  </th>
                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">TCP</p>
                  </th>
                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">Nom</p>
                  </th>
                  {
                    inputFilterValue.MP === "Prospection" &&
                    <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                      <p className="text-xs tracking-wide text-gray-600">Téléphone</p>
                    </th>
                  }
                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">Produit</p>
                  </th>
                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">Action</p>
                  </th>
                  <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                    <p className="text-xs tracking-wide text-gray-600">Commentaire</p>
                  </th>
                  {
                    inputFilterValue.MP === "VisiteEssai" &&
                    <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700">
                      <p className="text-xs tracking-wide text-gray-600">Clôture</p>
                    </th>
                  }
                </tr>
              </thead>

              <tbody>
                {
                  listOfOperations.map(el => (
                    <tr>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {el?.CurrentDate || (el?.createdAt ? new Date(el.createdAt).toLocaleDateString("fr-FR") : "")}
                        </p>
                      </td>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {el.ModeOperation}
                        </p>
                      </td>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {el.ModeOperation == "Devis" ? el.RBC : ""}
                        </p>
                      </td>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {el.for.Name}
                        </p>
                      </td>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {el.InfoGenerale.NomSociete}
                        </p>
                      </td>
                      {
                        inputFilterValue.MP === "Prospection" &&
                        <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                          <p className="text-sm font-bold text-navy-700 dark:text-white">
                            {el.InfoGenerale.Tel}
                          </p>
                        </td>
                      }
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {
                            accessList.Read &&
                            <IoEyeSharp
                              size={20}
                              color="gray"
                              className="cursor-pointer"
                              onClick={() => handleReportProductsModal(el)}
                            />
                          }
                        </p>
                      </td>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          <div className="flex">
                            {
                              accessList.Read &&
                              <MdPictureAsPdf
                                size={20}
                                color="gray"
                                className="cursor-pointer mr-4"
                                onClick={() => handleReportModal(el)}
                              />
                            }
                            {
                              accessList.Delete &&
                              <FaTrash
                                size={20}
                                color="#cf503f"
                                className="cursor-pointer"
                                onClick={() => handleDeleteReport(el._id)}
                              />
                            }
                          </div>
                        </p>
                      </td>
                      <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {el?.Comment}
                        </p>
                      </td>
                      {
                        inputFilterValue.MP === "VisiteEssai" &&
                        <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                          {
                            el.EtatFacturation === "V" ? (
                              <span className="text-sm font-bold text-green-600">Terminée</span>
                            ) : el.EtatFacturation === "A" ? (
                              <span className="text-sm font-bold text-red-600">Supprimée</span>
                            ) : (
                              accessList.Update &&
                              <Button
                                variant="gradient"
                                color="#cf503f"
                                size="sm"
                                onClick={() => handleOpenClotureDialog(el)}
                              >
                                <span>Clôture</span>
                              </Button>
                            )
                          }
                        </td>
                      }
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>

          {
            <div className="mt-4 flex items-center gap-4">
            <Button
              variant="text"
              className="flex items-center gap-2"
              onClick={prev}
              disabled={currentPagination === 1}
            >
              <IoMdArrowDropleftCircle size={30} />
            </Button>
            <div className="flex items-center gap-2">
              {currentPagination !== numberOfPaginations
                ? // paginations row
                  Array.from({
                    length: numberOfPages > 5 ? 5 : numberOfPages,
                  }).map((el, index) => {
                    const pageNumber = index + 1 + (currentPagination - 1) * 10;
                    return (
                      <IconButton {...getItemProps(pageNumber)}>
                        {pageNumber}
                      </IconButton>
                    );
                  })
                : // last pagination row
                  Array.from({ length: numberOfPages % 10 }).map((el, index) => {
                    const pageNumber = index + 1 + (currentPagination - 1) * 5;
                    return (
                      <IconButton {...getItemProps(pageNumber)}>
                        {pageNumber}
                      </IconButton>
                    );
                  })}
            </div>
            <Button
              variant="text"
              className="flex items-center gap-2"
              onClick={next}
              disabled={
                currentPagination === numberOfPaginations ||
                numberOfPaginations === 0
              }
            >
              <IoMdArrowDroprightCircle size={30} />
            </Button>
            </div>
          }

        </div>
      }
    </Card>
  );
}

export default ListOfOperations;
